import type { DeepString } from "@/lib/i18n";

/**
 * CPhotoGallery - polskie tłumaczenia (Galeria zdjęć - lista galerii + galeria).
 *
 * `photosCount(n)` - polska odmiana rzeczownika "zdjęcie" przez liczebnik:
 *   1 -> "zdjęcie", 2-4 (oprócz 12-14) -> "zdjęcia", reszta -> "zdjęć".
 */
export const pl = {
  emptyData: "Brak danych do wyświetlenia.",
  emptyList: "Brak galerii do wyświetlenia.",
  emptyGallery: "Ta galeria nie zawiera jeszcze zdjęć.",
  backToList: "<- Wróć do listy galerii",
  openImage: "Otwórz zdjęcie",
  /** `photosCount(5)` -> "5 zdjęć". */
  photosCount: (n: number): string => {
    const abs = Math.abs(n);
    const last = abs % 10;
    const lastTwo = abs % 100;
    let word: string;
    if (abs === 1) word = "zdjęcie";
    else if (last >= 2 && last <= 4 && !(lastTwo >= 12 && lastTwo <= 14))
      word = "zdjęcia";
    else word = "zdjęć";
    return `${n} ${word}`;
  },
  paginationAria: "Paginacja",
  /** `paginationLabel(2, 7)` -> "Strona 2 z 7". */
  paginationLabel: (page: number, totalPages: number) =>
    `Strona ${page} z ${totalPages}`,
  paginationHint: "Paginacja zostanie podłączona w kolejnej iteracji",
} as const;

export type CPhotoGalleryTranslations = DeepString<typeof pl>;
